import { render, staticRenderFns } from "./newStatement.vue?vue&type=template&id=deac60ac&scoped=true"
import script from "./newStatement.vue?vue&type=script&lang=js"
export * from "./newStatement.vue?vue&type=script&lang=js"
import style0 from "./newStatement.vue?vue&type=style&index=0&id=deac60ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deac60ac",
  null
  
)

export default component.exports